<template>
  <!-- Delete Modal -->
  <b-modal
    v-model="showModal"
    title="Confirm Delete"
    title-tag="h4"
    title-class="text-white"
    ok-title="Delete"
    ok-variant="danger"
    cancel-variant="outline-secondary"
    header-bg-variant="danger"
    header-text-variant="white"
    centered
    no-close-on-backdrop
    hide-header-close
    class="delete-modal"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    :no-close-on-esc="loading"
    :no-close-on-backdrop="loading"
    @ok="handleOk"
    @cancel="handleCancel"
    @hide="handleHide"
    ref="modal"
  >
    <div class="text-center delete-modal-content">
      <div class="mb-3">
        <div class="delete-icon-container mb-2">
          <feather-icon icon="AlertCircleIcon" size="42" class="text-danger" />
        </div>
        <h4 class="font-weight-bold">Are you sure?</h4>
        <div class="delete-description">
          <p class="mb-1">You want to delete the {{ resourceName }}</p>
          <p class="mb-2">
            {{ itemName }}
          </p>
          <p class="warning-text">This action cannot be undone.</p>
        </div>
      </div>
    </div>

    <!-- Custom Footer - Shows loading indicator -->
    <template #modal-footer>
      <div class="d-flex w-100 justify-content-center">
        <!-- Cancel Button -->
        <b-button
          variant="outline-secondary"
          size="lg"
          class="cancel-btn mr-2"
          @click="handleCancel"
          :disabled="loading"
        >
          Cancel
        </b-button>

        <!-- Delete Button -->
        <b-button
          variant="danger"
          size="lg"
          class="delete-btn"
          @click="handleOk"
          :disabled="loading"
        >
          <template v-if="loading">
            <b-spinner small class="mr-1"></b-spinner>
            Deleting...
          </template>
          <template v-else>
            <feather-icon icon="TrashIcon" size="16" class="mr-50" />
            Delete
          </template>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BButton, BModal, BSpinner } from 'bootstrap-vue';

export default {
  name: 'DeleteConfirmationModal',

  components: {
    BButton,
    BModal,
    BSpinner,
    featherIcon: () => import('@core/components/feather-icon/FeatherIcon.vue'),
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    resourceName: {
      type: String,
      required: true,
    },
    itemName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(value) {
        // If loading is active, prevent modal from closing
        if (this.loading && !value) {
          return;
        }

        this.$emit('update:show', value);
        if (!value) {
          this.$emit('onHide');
        }
      },
    },
  },

  methods: {
    handleOk(bvModalEvent) {
      console.log('Delete confirmation - handleOk called with loading:', this.loading);
      // Prevent modal from closing if loading
      if (this.loading) {
        if (bvModalEvent) bvModalEvent.preventDefault();
        console.log('Delete confirmation - prevented close due to loading');
        return;
      }

      // Emit deleteConfirmed event for parent to handle
      console.log('Delete confirmation - emitting deleteConfirmed');
      this.$emit('deleteConfirmed');

      // Prevent default modal close behavior
      // Let parent component control when to close the modal after delete completes
      if (bvModalEvent) bvModalEvent.preventDefault();
    },

    handleCancel(bvModalEvent) {
      console.log('Delete confirmation - handleCancel called with loading:', this.loading);
      // If loading, prevent closing
      if (this.loading) {
        if (bvModalEvent) bvModalEvent.preventDefault();
        console.log('Delete confirmation - prevented cancel due to loading');
        return;
      }

      // Emit hideModal for parent to handle
      console.log('Delete confirmation - emitting hideModal');
      this.$emit('hideModal');
    },

    handleHide(bvModalEvent) {
      console.log('Delete confirmation - handleHide called with loading:', this.loading);

      // Prevent modal from closing if loading
      if (this.loading && bvModalEvent) {
        bvModalEvent.preventDefault();
        console.log('Delete confirmation - prevented hide due to loading');
        return;
      }

      console.log('Delete confirmation - emitting onHide');
      this.$emit('onHide');
    },
  },
};
</script>
